import * as React from "react"
const SvgMusicNote = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M10 21.286q-1.65 0-2.825-1.175T6 17.286c0-1.65.392-2.042 1.175-2.825Q8.35 13.286 10 13.286q.575 0 1.063.137.486.138.937.413v-9.55a.97.97 0 0 1 .287-.713.97.97 0 0 1 .713-.287h4a.97.97 0 0 1 .712.287q.288.288.288.713v2q0 .424-.288.712a.97.97 0 0 1-.712.288h-3v10q0 1.65-1.175 2.825T10 21.286" />
  </svg>
)
export default SvgMusicNote
